<template>
  <div class="work-order-info">
    <div class="header-info">
      <div class="header-info-topic">
        <h2 class="header-info-title">{{ wkDetailInfo.wkOrderTopic }}</h2>
        <slot name="other-btns"></slot>
        <el-button
          type="primary"
          size="small"
          plain
          @click="$router.push({ name: routerName })"
        >
          返回
        </el-button>
      </div>
      <div class="header-info-detail">
        <span class="user-name">{{ wkDetailInfo.authorName }}</span>
        <div class="create-time">
          <span class="date">{{ wkDetailInfo.createdTime }}</span>
        </div>
      </div>
    </div>

    <el-form label-width="70px" class="main-info">
      <el-form-item label="工单编号：">
        <div>{{ wkDetailInfo.wkOrderId }}</div>
      </el-form-item>
      <el-form-item label="工单类型：">
        <div>{{ wkDetailInfo.wkType }}</div>
      </el-form-item>
      <el-form-item label="问题描述：">
        <div
          style="
            white-space: normal;
            word-wrap: break-word;
            word-break: break-all;
          "
        >
          {{ wkDetailInfo.desc }}
        </div>
      </el-form-item>
      <el-form-item label="提交时间：">
        <div>{{ wkDetailInfo.createdTime }}</div>
      </el-form-item>
      <el-form-item label="关注人:" v-if="relationUserList">
        <div style="display: flex; align-items: center">
          <span>{{ relationUserList }}</span>
          <el-button
            type="text"
            style="margin-left: 10px; padding: 0"
            @click="showDialog"
            v-if="$route.name === 'workmange.workQuality.detail'"
            >编辑
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label="关联客户:">
        <div style="display: flex; flex-direction: column">
          <el-card
            v-for="(item, index) in wkDetailInfo.customerList"
            :key="index"
            class="customer"
          >
            <span slot="header">客户{{ index + 1 }}</span>
            <div class="customer-item">
              <div class="customer-item-info">
                <span>电话</span>
                <el-input v-model="item.customerPhone" :readonly="true">
                </el-input>
                <el-button
                  type="text"
                  class="copy"
                  @click="copyNow"
                  :data-clipboard-text="item.customerPhone"
                  >复制
                </el-button>
              </div>
              <div class="customer-item-info">
                <span>ID</span>
                <el-input v-model="item.customerId" :readonly="true">
                </el-input>
                <el-button
                  type="text"
                  class="copy"
                  @click="copyNow"
                  :data-clipboard-text="item.customerId"
                  >复制
                </el-button>
              </div>
              <div class="customer-item-info">
                <span>备注</span>
                <el-input v-model="item.remark" :readonly="true"> </el-input>
                <el-button
                  type="text"
                  class="copy"
                  @click="copyNow"
                  :data-clipboard-text="item.remark"
                  >复制</el-button
                >
              </div>
            </div>
          </el-card>
        </div>
      </el-form-item>
      <el-form-item label="关联工单:" v-if="wkDetailInfo.relationWorkOrderId">
        <router-link
          :to="{
            name: 'workmange.workOrderList.relationdetail',
            query: {
              wkOrderId: wkDetailInfo.relationWorkOrderId,
            },
          }"
          target="_blank"
        >
          {{ wkDetailInfo.relationWorkOrderId }}
        </router-link>
      </el-form-item>
      <el-form-item label="工单状态：">
        <div>{{ wkDetailInfo.status | statusFilters }}</div>
      </el-form-item>
      <el-form-item
        label="审核状态："
        v-if="wkDetailInfo.qaProcessType == 'EXAMINE'"
      >
        <div>{{ wkDetailInfo.handleResult | resultFilters }}</div>
      </el-form-item>
      <el-form-item label="当前承接：">
        <div>
          {{ wkDetailInfo.acceptorName }}
          <slot name="remind-btns"></slot>
        </div>
      </el-form-item>
      <el-form-item v-if="imgList.length > 0" label="图片：">
        <div class="content">
          <div class="image-list">
            <el-image
              v-for="(item, index) in imgList"
              :key="index"
              style="width: 100px; height: 100px"
              :src="item.appendisUrl"
              :preview-src-list="srcList"
              fit="fill"
            ></el-image>
          </div>
        </div>
      </el-form-item>
      <el-form-item v-if="fileList.length > 0" label="附件：" class="no-wrap">
        <span @click="downloadFile()" class="c-pointer mr-16 color-blue">
          {{ fileList[0].fileName }}
        </span>
        <span @click="downloadFile()" class="c-pointer color-green">
          点击查看
        </span>
      </el-form-item>
      <el-form-item v-if="chatList.length" label="附件详情：">
        <span class="c-pointer mr-16 color-blue" @click="openChatLog">
          呗呗聊天记录
        </span>
        <span class="c-pointer color-green" @click="openChatLog">
          点击查看
        </span>
      </el-form-item>
    </el-form>
    <el-dialog title="编辑关注人" :visible.sync="dialog">
      <el-select
        v-model="leftUserList"
        placeholder="请输入成员名称，可搜索"
        filterable
        value-key="userId"
        multiple
        collapse-tags
        remote
        :remote-method="remoteMethodUser"
      >
        <el-option
          v-for="(item, index) in rightUserList"
          :key="index"
          :label="item.username"
          :value="item"
        >
          <span style="float: left">{{ item.username }}</span>
          <span style="float: right; color: #8492a6">{{ item.userId }}</span>
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" plain @click="dialog = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="updateRelationList">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="呗呗聊天记录" :visible.sync="chatDialog">
      <chatLog
        :chatId="chatList[0].appendisUrl"
        :userId="wkDetailInfo.customerList[0].businessId"
        v-if="chatDialog"
      ></chatLog>
    </el-dialog>
  </div>
</template>

<script>
import mQuillEditor from "./mQuillEditor";
import chatLog from "./chatLog";
import Clipboard from "clipboard";
import api from "plus/api";

export default {
  name: "workOrderDetail.workOrderInfo",
  components: {
    mQuillEditor,
    chatLog,
  },
  filters: {
    statusFilters(val) {
      switch (parseInt(val)) {
        case 0:
          return "待处理";
        case 1:
          return "已处理";
        case 2:
          return "已关闭";
        case 3:
          return "已驳回";
        case 4:
          return "处理中";
        default:
          return "";
      }
    },
    resultFilters(val) {
      const filters = {
        NOT_PASS: "未通过",
        PASS: "通过",
        UNDER_REVIEW: "审核中",
        OTHERS: "其他",
      };
      return filters[val];
    },
  },
  props: {
    // headerTitleBG: {type: String, default: '#f5f5f5'},
    isShowAttatchmentInfo: { type: Boolean, default: false },
    isShowFileInfo: { type: Boolean, default: false },
    wkDetailInfo: {
      type: Object,
      default: () => {
        return {
          wkOrderId: "",
          wkType: "",
          status: "",
          authorName: "",
          createdTime: "",
          desc: "",
          wkOrderTopic: "",
          appendixInfos: [],
          acceptorName: "",
          relationUserList: [],
          relationWorkOrderId: "",
          customerList: [],
          qaProcessType: "",
        };
      },
    },
    routerName: { type: String, default: "" },
  },
  data() {
    return {
      appendUrl: "https://cdn-workorder.meb.com",
      dialog: false,
      searchName: "",
      rightUserList: [],
      allUserListOptions: [],
      leftUserList: [],
      currentNodeKey: "",
      rightChecks: [],
      chatDialog: false,
    };
  },
  computed: {
    srcList() {
      const tempData = [];
      for (let item of this.imgList) {
        tempData.push(item.appendisUrl);
      }
      return tempData;
    },
    imgList() {
      const tempData = [];
      if (this.wkDetailInfo.appendixInfos) {
        for (let item of this.wkDetailInfo.appendixInfos) {
          if (item.attachmentType === "IMAGE") {
            tempData.push(item);
          }
        }
      }
      return tempData;
    },
    fileList() {
      const tempData = [];
      if (this.wkDetailInfo.appendixInfos) {
        for (let item of this.wkDetailInfo.appendixInfos) {
          if (item.attachmentType === "FILE") {
            // let fileName = item.appendisUrl.split("-");
            // fileName.pop();
            // fileName = fileName.join("");
            // fileName = fileName.split("/");
            // fileName = fileName.pop();
            // item.fileName = fileName;
            item.fileName = item.appendisName;
            tempData.push(item);
          }
        }
      }
      return tempData;
    },
    relationUserList() {
      return (
        this.wkDetailInfo &&
        this.wkDetailInfo.relationUserList &&
        this.wkDetailInfo.relationUserList
          .map((item) => item.username)
          .join(", ")
      );
    },
    chatList() {
      const tempData = [];
      if (this.wkDetailInfo.appendixInfos) {
        for (let item of this.wkDetailInfo.appendixInfos) {
          if (item.attachmentType === "CONVERSATION") {
            tempData.push(item);
          }
        }
      }
      return tempData;
    },
  },
  watch: {
    searchName(val) {
      this.$refs.tree2.filter(val);
    },
  },
  created() {
    this.getDepList();
  },
  methods: {
    showDocument() {},
    copyNow() {
      var clipboard = new Clipboard(".copy");
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    downloadFile() {
      let fileUrl = this.fileList[0].appendisUrl;
      const fileName = this.getFileName(fileUrl);
      if (fileUrl.endsWith(".pdf")) {
        window.open(fileUrl);
      } else if (fileUrl.endsWith(".txt")) {
        fileUrl = fileUrl.replace(/\\/g, "/");
        const xhr = new XMLHttpRequest();
        xhr.open("GET", fileUrl, true);
        xhr.responseType = "blob";
        xhr.onload = () => {
          if (xhr.status === 200) {
            // 获取文件blob数据并保存
            this.saveAs(xhr.response, fileName);
          }
        };
        xhr.send();
      } else {
        const eleLink = document.createElement("a");
        eleLink.download = fileName;
        eleLink.style.display = "none";
        eleLink.href = fileUrl;

        eleLink.click();
        document.body.removeChild(eleLink);
      }
    },
    getFileName(fileUrl) {
      let fileName = fileUrl.split("/");
      fileName = fileName[fileName.length - 1].split("-")[0];
      return fileName;
    },
    saveAs(data, name) {
      var urlObject = window.URL || window.webkitURL || window;
      var export_blob = new Blob([data]);
      var save_link = document.createElement("a");
      save_link.href = urlObject.createObjectURL(export_blob);
      save_link.download = name;
      save_link.click();
    },
    handleTime(item) {
      if (item) {
        const tempTimeArr = item.split(" ");
        let date = tempTimeArr[0];
        let time = tempTimeArr[1];

        date = date.split("-");
        date.shift();
        date = date.join("-");

        time = time.split(":");
        time.pop();
        time = time.join(":");

        return date + " " + time;
      } else {
        return "";
      }
    },
    showDialog() {
      this.leftUserList =
        this.wkDetailInfo && this.wkDetailInfo.relationUserList;
      this.dialog = true;
    },
    getDepList() {
      return api.role.getAllUsers().then((res) => {
        this.allUserListOptions = res.data.data.map((item) => {
          return {
            username: item.realName,
            userId: item.userId,
          };
        });
        this.rightUserList = this.allUserListOptions.splice(0, 10);
      });
    },
    remoteMethodUser(query) {
      if (query) {
        const selecteIds = this.leftUserList.map((item) => item.userId);
        const selecteItems = this.allUserListOptions.filter((item) =>
          selecteIds.includes(item.userId),
        );
        let filters = this.allUserListOptions
          .filter(
            (item) =>
              item.username.includes(query) &&
              !selecteIds.includes(item.userId),
          )
          .slice(0, 10);

        this.rightUserList = [...selecteItems, ...filters];
      } else {
        const selecteIds = this.leftUserList.map((item) => item.userId);
        const selecteItems = this.allUserListOptions.filter((item) =>
          selecteIds.includes(item.userId),
        );
        const filters = this.rightUserList.filter(
          (item) => !selecteIds.includes(item.userId),
        );
        this.rightUserList = [...selecteItems, ...filters];
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    changeChecked() {
      this.$forceUpdate();
    },
    handleCheckChange() {
      const items = this.$refs.tree2.getCheckedNodes(true);
      this.rightChecks = items.map((item) => {
        return {
          userId: item.id,
          username: item.name,
        };
      });
    },
    deleRightUser(index) {
      this.rightChecks.splice(index);
    },
    updateRelationList() {
      let params = {
        relationUserList: this.leftUserList,
        workOrderId: this.wkDetailInfo.wkOrderId,
      };
      api.work.editRelationUser(params).then((res) => {
        if (res.data.success) {
          this.$message.success("更新成功");
          location.reload();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    openChatLog() {
      this.chatDialog = true;
    },
  },
};
</script>

<style lang="less" scoped>
.work-order-info {
  width: 100%;

  .header-info {
    width: 100%;
    padding: 30px 40px;
    border-bottom: 1px solid #e2e2e2;
    box-sizing: border-box;
    background: #fff;

    .header-info-topic {
      display: flex;
      justify-content: space-between;
      align-items: self-start;

      .header-info-title {
        display: inline-block;
        width: 80%;
        font-size: 30px;
        line-height: 42px;
        margin-bottom: 26px;
        color: #3c78e8;
      }
    }

    .header-info-detail {
      font-size: 16px;
      color: #666;
      display: flex;

      .user-name {
        margin-right: 25px;
      }

      .create-time {
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
    }
  }

  /deep/ .main-info {
    padding: 31px 46px 30px 46px;
    box-sizing: border-box;
    background: #fff;
    color: #333;

    .el-form-item {
      .el-form-item__label {
        line-height: 20px;
        padding-right: 27px;
        box-sizing: content-box;
      }

      .el-form-item__content {
        line-height: 20px;

        .image-list {
          margin-bottom: 20px;

          .el-image {
            width: 120px !important;
            height: 120px !important;

            margin-right: 14px;
          }
        }
      }
    }

    .info-item {
      display: flex;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      &.image {
        .label {
          color: #666;
        }
      }

      .label {
        width: 70px;
        font-size: 14px;
        margin-right: 27px;
      }

      .content {
        .image-list {
          margin-bottom: 20px;

          .el-image {
            width: 120px !important;
            height: 120px !important;

            margin-right: 14px;
          }
        }
      }
    }
  }

  .customer {
    margin-bottom: 20px;
    width: 50%;

    .customer-item-info {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        display: inline-block;
        width: 50px;
        padding: 0 10px;
      }

      .copy {
        margin-left: 20px;
      }
    }
  }
}

.grop-box {
  display: flex;
  border: solid 1px #eee;

  .group-left {
    width: 200px;
    height: 200px;
    overflow: auto;
    border-right: solid 1px #eee;
    padding-left: 30px;
    box-sizing: border-box;
  }

  .group-right {
    width: 200px;
    height: 200px;
    overflow: auto;

    /deep/ input.el-input__inner {
      width: 100%;
    }

    .tag-list {
      width: 200px;
      display: flex;
      flex-wrap: wrap;

      .tag-item {
        margin: 10px;
      }
    }
  }

  .group-title {
    font-size: 14px;
    line-height: 2em;
    overflow: auto;
    text-align: center;
  }
}
</style>
